import tw from 'tailwind-styled-components'
import styled, { css } from 'styled-components'




const Div = tw.div``

const TableContainer = tw.div`
rounded-lg 
border 
border-borderTable
`
const ThreadHtml = tw.thead``

const TrHtml = tw.tr``

const TableHtml = tw.table`
min-w-full 
divide-y 
divide-borderTable
`

const Th = tw.th`
px-4 
text-sm 
font-semibold 
text-gray-900
`

const iconUpDown = `
w-4 
h-4 
cursor-pointer 
text-gray-300
`

const FlexTitle = tw.div`
flex 
items-center 
justify-between
font-semibold
text-[14px]
text-darkGray
min-w-[91px]
`

const Tbody = tw.tbody`
divide-y 
divide-borderTable 
bg-white
`

const Tr = tw.tr`
divide-x 
divide-borderTable
hover:bg-tableHover 
hover:font-bold 
cursor-pointer
text-xs
`

const Td = tw.td`
whitespace-nowrap 
px-4 
h-12 
text-textSelect
`

const activeStyle = `
text-active
font-bold
text-[11px]
border
border-active
px-3
rounded-[14px]
h-[15px]
`
const inactiveStyle = `
text-orange
font-bold
text-[11px]
border
border-orange
px-3
rounded-[14px]
`
const FooterContainer = tw.footer`
flex
items-center
justify-between
`
const FooterText = tw.div`
text-sm
font-light
text-darkGray/70
`

export {
  TableContainer,
  TableHtml,
  Th,
  iconUpDown,
  FlexTitle,
  Tbody,
  Tr,
  Td,
  activeStyle,
  inactiveStyle,
  Div,
  TrHtml,
  ThreadHtml,
  FooterContainer,
  FooterText
}
